// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"56d78954","498":"369ac720"}[chunkId] + ".chunk.js";
};